import styles from "./SolarSystemDetails.module.scss";
import { memo, useCallback, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import CommonDialog from "../../../common/components/dialog/CommonDialog";
import { toast } from "react-toastify";
import CommonLoadingSpinnerForPage from "../../../common/components/loading-spinner/CommonLoadingSpinnerForPage";
import { useNavigate, useParams } from "react-router-dom";
import useWindowDimensions, { CurrentScreen } from "../../../hooks/use-window-dimensions";
import { useLazyViewProductQuery } from "../../../service/solar-product-service";
import { AvailableOffer, SolarProductObject } from "../../../model/solar-product/solar-product-with-recommendations";
import { Money } from "../../../model/common/money";

type Props = {};



const SolarSystemDetails: React.FC<Props> = memo((props: any) => {
	const currentScreen: CurrentScreen = useWindowDimensions();

	const settings: Settings = {
		dots: currentScreen.isMobile,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,

		arrows: true,
		beforeChange(_, nextSlide) {
			setSelectedImg(nextSlide);
		},
	};

	const navigator = useNavigate();

	const { id } = useParams();

	const [previewDetails, setPreviewDetails] = useState(0);
	const [selectedImg, setSelectedImg] = useState(0);
	const [showDialog, setShowDialog] = useState(false);
	const [paymentBreakdown, setPaymentBreakdown] = useState<AvailableOffer>();
	const [temporarySelectedPaymentBreakdown, setTemporarySelectedPaymentBreakdown] = useState<AvailableOffer>();
	const [solarProduct, setSolarProduct] = useState<SolarProductObject>();

	const [getProduct, { isLoading }] = useLazyViewProductQuery()

	const fetchSolarSystemDetails = useCallback(async () => {
		try {
			if (id != null) {
				let response = await getProduct(id, true).unwrap();

				setSolarProduct({
					solarProduct: {
						...response.solarProduct.solarProduct,
					},
					availableOffers: [...response.solarProduct.availableOffers],
				});

				const sortedAvailableOffers = [...response.solarProduct.availableOffers].sort((a: AvailableOffer, b: AvailableOffer) => a.months - b.months);

				setPaymentBreakdown(sortedAvailableOffers[0]);
				setTemporarySelectedPaymentBreakdown(sortedAvailableOffers[0]);
			}
		} catch (error) {
			toast.error("Error loading Solar System Details");
		}
	}, [getProduct, id]);

	useEffect(() => {
		fetchSolarSystemDetails();
	}, [fetchSolarSystemDetails]);

	const confirmPayment = () => {
		setPaymentBreakdown(temporarySelectedPaymentBreakdown);
		setShowDialog(false);
	};

	const flag = !(solarProduct?.solarProduct.quantityAvailableForSale != null && solarProduct?.solarProduct.quantityAvailableForSale > 0);

	return (
		<CommonLoadingSpinnerForPage loading={isLoading}>
			<div className={styles.contentContainer}>
				<div className={styles.goBackButtonContainer}>
					<div className={styles.goBackButton} onClick={() => navigator(-1)}>
						<div className={styles.arrow}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
								<g data-name="21.Arrow Left">
									<path d="M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2z" />
									<path d="M10.293 16.707 5.586 12l4.707-4.707 1.414 1.414L8.414 12l3.293 3.293-1.414 1.414z" />
									<path d="M7 11h11v2H7z" />
								</g>
							</svg>
						</div>
						Go back
					</div>
				</div>
				<div className={styles.itemContainer}>
					<div className={styles.leftPane}>
						<div className={styles.galleryContainer}>
							<Slider
								{...settings}
								ref={slider => {
									slider?.slickGoTo(selectedImg);
								}}
							>
								{solarProduct?.solarProduct.images &&
									solarProduct?.solarProduct.images.map(x => (
										<div key={x.id} className={styles.bigImage}>
											<img src={x.imageUrl} alt="Solar Panel" />
										</div>
									))}
							</Slider>
							<div className={styles.smallImageContainer}>
								{solarProduct?.solarProduct.images &&
									solarProduct?.solarProduct.images.map((x, index) => (
										<div
											key={x.id}
											className={`${styles.smallImage} ${selectedImg === index ? styles.smallImageSelected : ""}`}
											onClick={() => setSelectedImg(index)}
										>
											<img src={x.imageUrl} alt="Solar Panel" />
										</div>
									))}
							</div>
						</div>
					</div>

					<div className={styles.rightPane}>
						<div className={styles.informationContainer}>
							<div className={styles.topBar}>
								<div className={styles.leftSide}>
									{/* <div className={styles.redTag}>Hotsale</div>
                                    <div className={styles.stars}>
                                        <ReactStars
                                            count={5}
                                            onChange={() => null}
                                            value={4}
                                            size={24}
                                            color2={'#ffd700'} />
                                            4.7
                                    </div> */}
								</div>
								<div className={styles.rightSide}>
									{/* <div className={styles.someText}>
                                        50 hours 12 years plan
                                    </div> */}
								</div>
							</div>
							<div className={styles.titlePane}>
								<div className={styles.title}>{solarProduct?.solarProduct.productName}</div>
								<div className={styles.description}>{solarProduct?.solarProduct.packageDescription}</div>
							</div>
							<div className={styles.brandAndAvailability}>
								{/* <div className={styles.brand}>Brand</div>
                                <div className={styles.brandValue}>Apple</div>
                                |  */}
								<div className={styles.brand}>Availability</div>
								{solarProduct?.solarProduct.quantityAvailableForSale != null && solarProduct?.solarProduct.quantityAvailableForSale > 0 ? (
									<div className={styles.availabilityValueGreen}>In Stock</div>
								) : (
									<div className={styles.availabilityValueRed}>Not Available</div>
								)}
							</div>
							<div className={styles.paymentPlansPane}>
								{!currentScreen.isMobile && (
									<>
										<div>
											<div className={styles.cost}>{new Money(solarProduct?.solarProduct.price?.currency ?? '', solarProduct!.solarProduct.price.amount * 0.3).toString()}</div>
											<div className={styles.costDescription}>30% Initial deposit</div>
										</div>
										<div>
											<div className={styles.cost2}>
												₦
												{paymentBreakdown
													? paymentBreakdown.price.toLocaleString()
													: solarProduct?.availableOffers && solarProduct?.availableOffers.sort((a, b) => a.months - b.months)[0].price!.toLocaleString()}
											</div>
											<div className={styles.costDescription}>Amount payable per month</div>
										</div>
									</>
								)}
								<div className={styles.paymentPlansBtn} onClick={() => setShowDialog(true)}>
									Available payment plans
									<div style={{ width: "30px", height: "30px" }}>
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
											<path
												d="M17 8v4a1 1 0 0 1-2 0v-1.586l-6.293 6.293a1 1 0 1 1-1.414-1.414L13.586 9H12a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1z"
												style={{ fill: "#f97c4b" }}
												data-name="Up Right"
											/>
										</svg>
									</div>
								</div>
							</div>
						</div>
						<div className={styles.purchaseContainer}>
							<div className={styles.purchaseInfo}>
								<div className={styles.cardInfo}>
									<div className={styles.cardTitle}>Highest possible tenure</div>
									<div className={styles.cardValue}>{solarProduct?.availableOffers.sort((a, b) => b.months - a.months)[0].months} months</div>
								</div>
								<div className={styles.cardInfo}>
									<div className={styles.cardTitle}>Full price as of today</div>
									<div className={styles.cardValue}>
										{new Money(solarProduct?.solarProduct.price?.currency ?? '', 
											solarProduct!.solarProduct.price.amount * 0.3 +
											solarProduct?.availableOffers.sort((a, b) => a.months - b.months)[0].price.amount! *
											solarProduct?.availableOffers.sort((a, b) => a.months - b.months)[0].months!)
											.toLocaleString()}
									</div>
								</div>
							</div>
							{!currentScreen.isMobile && (
								<button
									className={`${styles.addToCartBtn} ${flag ? styles.disabled : ""}`}
									disabled={!(solarProduct?.solarProduct.quantityAvailableForSale != null && solarProduct?.solarProduct.quantityAvailableForSale > 0)}
									onClick={() => navigator("confirmation", { state: { solarProduct: solarProduct, selectedPaymentPlan: paymentBreakdown } })}
								>
									Buy
									<svg width={25} viewBox="0 -1 32 32" fill="var(--app-primary-title)" stroke="var(--app-primary-title)">
										<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
										<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
										<g id="SVGRepo_iconCarrier">
											<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
												<g id="Icon-Set" transform="translate(-464.000000, -724.000000)" fill="var(--app-base-white)">
													<path
														d="M488,750 C486.896,750 486,750.896 486,752 C486,753.104 486.896,754 488,754 C489.104,754 490,753.104 490,752 C490,750.896 489.104,750 488,750 L488,750 Z M478,750 C476.896,750 476,750.896 476,752 C476,753.104 476.896,754 478,754 C479.104,754 480,753.104 480,752 C480,750.896 479.104,750 478,750 L478,750 Z M491,744 C491,745.104 490.104,746 489,746 L478,746 C476.896,746 476,745.104 476,744 L474.333,734 L493.5,734 L491,744 L491,744 Z M473.97,732 L471.475,724 L465,724 C464.447,724 464,724.448 464,725 C464,725.553 464.447,726 465,726 L470,726 L472.011,732 L472,732 L474,744 C474,746.209 475.791,748 478,748 L489,748 C491.209,748 493,746.209 493,744 L496,732 L473.97,732 L473.97,732 Z"
														id="cart"
													></path>
												</g>
											</g>
										</g>
									</svg>
								</button>
							)}
						</div>
						<div className={styles.detailsContainer}>
							<div className={styles.tabs}>
								<div className={previewDetails === 0 ? styles.selectedTab : styles.unselectedTab} onClick={() => setPreviewDetails(0)}>
									System Overview
								</div>
								<div className={previewDetails === 1 ? styles.selectedTab : styles.unselectedTab} onClick={() => setPreviewDetails(1)}>
									Payment Breakdown
								</div>
							</div>
							{previewDetails === 0 && (
								<div className={styles.details}>
									<div className={styles.row}>
										<div className={styles.property}>Battery</div>
										<div className={styles.value}>{solarProduct?.solarProduct.batteryType}</div>
									</div>
									<div className={styles.row}>
										<div className={styles.property}>Battery Voltage</div>
										<div className={styles.value}>{solarProduct?.solarProduct.batteryType}V</div>
									</div>
									<div className={styles.row}>
										<div className={styles.property}>Inverter</div>
										<div className={styles.value}>{solarProduct?.solarProduct.inverterType}</div>
									</div>
									<div className={styles.row}>
										<div className={styles.property}>Component Name</div>
										<div className={styles.value}>{solarProduct?.solarProduct.type}</div>
									</div>
									<div className={styles.row}>
										<div className={styles.property}>Energy Capacity</div>
										<div className={styles.value}>{solarProduct?.solarProduct.productCapacity}KvA</div>
									</div>
									<div className={styles.row}>
										<div className={styles.property}>Warranty</div>
										<div className={styles.value}>{solarProduct?.solarProduct.warranty} years</div>
									</div>
								</div>
							)}
							{previewDetails === 1 &&
								(paymentBreakdown ? (
									<div className={styles.details}>
										<div className={styles.row}>
											<div className={styles.property}>{paymentBreakdown.months} Monthly payments of</div>
											<div className={styles.value}>₦{paymentBreakdown.price.toLocaleString()} / Month</div>
										</div>
										<div className={styles.row}>
											<div className={styles.property}>Initial deposit of</div>
											<div className={styles.value}>{new Money(solarProduct?.solarProduct.price?.currency ?? '', solarProduct?.solarProduct.price.amount! * 0.3).toLocaleString()}</div>
										</div>
										<div className={styles.row}>
											<div className={styles.property}>Total payment of</div>
											<div className={styles.value}>{new Money(paymentBreakdown.price.currency, paymentBreakdown.months * paymentBreakdown.price.amount).toLocaleString()}</div>
										</div>
									</div>
								) : (
									<div className={styles.details}>
										<div className={styles.selectAvailablePayment}>Select one of the available payment plans</div>
									</div>
								))}
						</div>
					</div>
				</div>
			</div>
			{currentScreen.isMobile && (
				<div className={styles.stickyBottomBar}>
					<div>
						<div className={styles.cost2}>₦1,240,983</div>
						<div className={styles.costDescription}>Amount payable per month</div>
					</div>
					<button
						className={`${styles.addToCartBtn} ${flag ? styles.disabled : ""}`}
						disabled={!(solarProduct?.solarProduct.quantityAvailableForSale != null && solarProduct?.solarProduct.quantityAvailableForSale > 0)}
						onClick={() => navigator("confirmation", { state: { solarProduct: solarProduct, selectedPaymentPlan: paymentBreakdown } })}
					>
						Buy
						<svg width={25} viewBox="0 -1 32 32" fill="var(--app-primary-title)" stroke="var(--app-primary-title)">
							<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
							<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
							<g id="SVGRepo_iconCarrier">
								<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
									<g id="Icon-Set" transform="translate(-464.000000, -724.000000)" fill="var(--app-base-white)">
										<path
											d="M488,750 C486.896,750 486,750.896 486,752 C486,753.104 486.896,754 488,754 C489.104,754 490,753.104 490,752 C490,750.896 489.104,750 488,750 L488,750 Z M478,750 C476.896,750 476,750.896 476,752 C476,753.104 476.896,754 478,754 C479.104,754 480,753.104 480,752 C480,750.896 479.104,750 478,750 L478,750 Z M491,744 C491,745.104 490.104,746 489,746 L478,746 C476.896,746 476,745.104 476,744 L474.333,734 L493.5,734 L491,744 L491,744 Z M473.97,732 L471.475,724 L465,724 C464.447,724 464,724.448 464,725 C464,725.553 464.447,726 465,726 L470,726 L472.011,732 L472,732 L474,744 C474,746.209 475.791,748 478,748 L489,748 C491.209,748 493,746.209 493,744 L496,732 L473.97,732 L473.97,732 Z"
											id="cart"
										></path>
									</g>
								</g>
							</g>
						</svg>
					</button>
				</div>
			)}
			{showDialog && (
				<CommonDialog onCloseDialog={() => setShowDialog(false)} key={1}>
					<div className={styles.dialogContainer}>
						<div className={styles.dialogTitle}>
							{!currentScreen.isMobile && <div></div>}
							<div className={styles.dialogTitleText}>All avaliable payment plans for this package</div>
								<div className={styles.closeDialogBtn} onClick={() => setShowDialog(false)}>
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<mask id="mask0_747_5514" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
											<rect width="20" height="20" fill="var(--app-primary-text-01)" />
										</mask>
										<g mask="url(#mask0_747_5514)"></g>
										<g clip-path="url(#clip0_747_5514)">
											<path
												d="M15.6534 4.34121C14.9111 3.59736 14.0293 3.00749 13.0584 2.60546C12.0876 2.20343 11.0468 1.99718 9.99603 1.99854C5.57736 1.99854 1.99536 5.58054 1.99536 9.99921C1.99536 12.2085 2.89136 14.2092 4.33936 15.6572C5.08158 16.4011 5.96345 16.9909 6.93431 17.393C7.90517 17.795 8.94589 18.0012 9.99669 17.9999C14.4154 17.9999 17.9974 14.4179 17.9974 9.99921C17.9974 7.78988 17.1014 5.78921 15.6534 4.34121ZM14.6254 14.6259C14.0182 15.2346 13.2967 15.7174 12.5024 16.0464C11.708 16.3755 10.8565 16.5443 9.99669 16.5432C6.38136 16.5432 3.45069 13.6125 3.45069 9.99721C3.44962 9.13742 3.61845 8.28589 3.94749 7.49155C4.27653 6.69722 4.75929 5.97573 5.36803 5.36854C5.97507 4.75979 6.69644 4.27702 7.49067 3.94798C8.2849 3.61893 9.13633 3.45011 9.99603 3.45121C13.6107 3.45121 16.5414 6.38188 16.5414 9.99654C16.5425 10.8562 16.3737 11.7077 16.0446 12.5019C15.7156 13.2962 15.2328 14.0175 14.624 14.6245L14.6254 14.6259Z"
												fill="black"
											/>
											<path
												d="M11.0247 9.99983L13.5947 7.42983C13.7214 7.29165 13.7899 7.10984 13.7859 6.92236C13.7818 6.73488 13.7055 6.55622 13.5728 6.42366C13.4402 6.2911 13.2615 6.2149 13.074 6.21096C12.8865 6.20701 12.7048 6.27564 12.5667 6.4025L12.5673 6.40183L9.99733 8.97183L7.42733 6.40183C7.28915 6.27506 7.10734 6.20656 6.91986 6.21062C6.73238 6.21469 6.55371 6.291 6.42116 6.42365C6.2886 6.55629 6.2124 6.73501 6.20845 6.92249C6.20451 7.10997 6.27313 7.29173 6.4 7.42983L6.39933 7.42917L8.96933 9.99916L6.39933 12.5692C6.32702 12.6355 6.26888 12.7158 6.22842 12.8052C6.18795 12.8946 6.16599 12.9912 6.16387 13.0893C6.16174 13.1875 6.17949 13.285 6.21604 13.376C6.25259 13.4671 6.3072 13.5498 6.37656 13.6193C6.44593 13.6887 6.52862 13.7433 6.61966 13.7799C6.71071 13.8165 6.80822 13.8344 6.90632 13.8323C7.00443 13.8302 7.10111 13.8083 7.19053 13.7679C7.27995 13.7275 7.36028 13.6694 7.42666 13.5972L7.42733 13.5965L9.99733 11.0265L12.5673 13.5965C12.6337 13.6688 12.714 13.7269 12.8033 13.7674C12.8927 13.8079 12.9894 13.8298 13.0875 13.832C13.1856 13.8341 13.2831 13.8163 13.3742 13.7798C13.4653 13.7432 13.548 13.6886 13.6174 13.6193C13.6868 13.5499 13.7415 13.4672 13.7781 13.3762C13.8147 13.2851 13.8325 13.1876 13.8305 13.0895C13.8284 12.9914 13.8065 12.8947 13.7661 12.8053C13.7257 12.7159 13.6676 12.6356 13.5953 12.5692L13.5947 12.5685L11.0247 9.99983Z"
												fill="black"
											/>
										</g>
										<defs>
											<clipPath id="clip0_747_5514">
												<rect width="16" height="16" fill="white" transform="translate(2 2)" />
											</clipPath>
										</defs>
									</svg>
									Close
								</div>
						</div>
						<div className={styles.dialogData}>
							{solarProduct?.availableOffers &&
								solarProduct?.availableOffers.map((x: AvailableOffer) => (
									<div
										className={`${styles.dataContainer} ${x.months === temporarySelectedPaymentBreakdown?.months ? styles.dataContainerSelected : ""}`}
										onClick={() => setTemporarySelectedPaymentBreakdown(x)}
									>
										<div className={styles.dataRow}>
											<div>
												<b>{x.months} Monthly</b> payments of
											</div>
											<div>
												<b>₦{x.price.toLocaleString()}</b> / Month
											</div>
										</div>
										<div className={styles.dataRow}>
											<div>Initial deposit of</div>
											<div>
												<b>{new Money(solarProduct?.solarProduct.price?.currency ?? '', solarProduct.solarProduct.price.amount * 0.3).toLocaleString()}</b>
											</div>
										</div>
										<div className={styles.dataRow}>
											<div>Total payment of</div>
											<div>
												<b>{new Money(solarProduct?.solarProduct.price?.currency ?? '', solarProduct.solarProduct.price.amount * 0.3 + x.months * x.price.amount).toLocaleString()}</b>
											</div>
										</div>
									</div>
								))}
						</div>
						<div className={styles.dialogBottom}>
							<button className={styles.gotItBtn} onClick={() => confirmPayment()}>
								Confirm payment plan
							</button>
						</div>
					</div>
				</CommonDialog>
			)}
		</CommonLoadingSpinnerForPage>
	);
});

export default SolarSystemDetails;
